import {Box, styled, ListAltIcon} from '../../../ui-library';

export const ClassNameBox = styled(Box)`
  display: flex;
  flex-direction: row;
  color: white;
  align-content: center;
  align-items: center;
  gap: 5px;
`;

export const AllClasses = styled(ListAltIcon)`
    color: #FFFFFF;
    align-self: center;
    cursor: pointer;
    z-index: var(--layer-1st);
`;
